var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCashbook = function SvgCashbook(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 24.636311,
    x2: 86,
    y2: 41.992191,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 21.5,
    x2: 86,
    y2: 150.5,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface3129161"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 43.75 8.59375 L 43.75 11.71875 L 6.25 11.71875 L 6.25 8.59375 C 6.25 8.164062 6.601562 7.8125 7.03125 7.8125 L 42.96875 7.8125 C 43.398438 7.8125 43.75 8.164062 43.75 8.59375 Z M 43.75 8.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 39.84375 33.59375 L 32.03125 33.59375 L 32.03125 32.03125 L 39.84375 32.03125 Z M 39.84375 22.65625 L 32.03125 22.65625 L 32.03125 24.21875 L 39.84375 24.21875 Z M 30.46875 22.65625 L 27.34375 22.65625 L 27.34375 24.21875 L 30.46875 24.21875 Z M 30.46875 17.96875 L 27.34375 17.96875 L 27.34375 19.53125 L 30.46875 19.53125 Z M 39.894531 17.96875 L 32.03125 17.96875 L 32.03125 19.53125 L 39.894531 19.53125 Z M 17.140625 28.90625 L 22.609375 28.90625 L 22.609375 27.34375 L 17.140625 27.34375 Z M 34.375 28.90625 L 39.84375 28.90625 L 39.84375 27.34375 L 34.375 27.34375 Z M 22.65625 17.96875 L 14.796875 17.96875 L 14.796875 19.53125 L 22.65625 19.53125 Z M 13.234375 32.03125 L 10.109375 32.03125 L 10.109375 33.59375 L 13.234375 33.59375 Z M 45.3125 8.59375 L 45.3125 41.40625 C 45.3125 42.699219 44.261719 43.75 42.96875 43.75 L 7.03125 43.75 C 5.738281 43.75 4.6875 42.699219 4.6875 41.40625 L 4.6875 8.59375 C 4.6875 7.300781 5.738281 6.25 7.03125 6.25 L 42.96875 6.25 C 44.261719 6.25 45.3125 7.300781 45.3125 8.59375 Z M 43.75 40.480469 C 43.503906 40.570312 43.242188 40.625 42.96875 40.625 L 7.03125 40.625 C 6.757812 40.625 6.496094 40.570312 6.25 40.480469 L 6.25 41.40625 C 6.25 41.835938 6.601562 42.1875 7.03125 42.1875 L 42.96875 42.1875 C 43.398438 42.1875 43.75 41.835938 43.75 41.40625 Z M 43.75 13.28125 L 6.25 13.28125 L 6.25 38.28125 C 6.25 38.710938 6.601562 39.0625 7.03125 39.0625 L 42.96875 39.0625 C 43.398438 39.0625 43.75 38.710938 43.75 38.28125 Z M 43.75 8.59375 C 43.75 8.164062 43.398438 7.8125 42.96875 7.8125 L 7.03125 7.8125 C 6.601562 7.8125 6.25 8.164062 6.25 8.59375 L 6.25 11.71875 L 43.75 11.71875 Z M 13.234375 22.65625 L 10.109375 22.65625 L 10.109375 24.21875 L 13.234375 24.21875 Z M 22.609375 32.03125 L 14.796875 32.03125 L 14.796875 33.59375 L 22.609375 33.59375 Z M 22.609375 22.65625 L 14.796875 22.65625 L 14.796875 24.21875 L 22.609375 24.21875 Z M 30.46875 32.03125 L 27.34375 32.03125 L 27.34375 33.59375 L 30.46875 33.59375 Z M 13.234375 17.96875 L 10.109375 17.96875 L 10.109375 19.53125 L 13.234375 19.53125 Z M 13.234375 17.96875 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCashbook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cashbook.2c4875ba.svg";
export { ForwardRef as ReactComponent };